<template>
    <div id="tree-info">
        <p v-for="(value, name) in nodes" :key="value">{{name}}: {{value}}</p>
    </div>
</template>

<script>
    export default {
        name: "TreeInfo",
        props:{
            nodes: Object
        }
    }
</script>

<style scoped>

</style>